import { request } from '@/api/request'

export const addFriend = async (userCode: string) => {
  const bodyFormData = new FormData();
  bodyFormData.set('friend_code', userCode);

  const { data } = await request.post(`/webapi/friend/me/add`, bodyFormData);
  return data.value
}

export const removeFriend = async (userId: string) => {
  const bodyFormData = new FormData();
  bodyFormData.set('friend_id', userId);

  const { data } = await request.post(`/webapi/friend/me/delete`, bodyFormData);
  return data.value
}